export const dashboardDetailsConstants = {
  GETALL_REQUEST: "DASHBOARDDETAILS_GETALL_REQUEST",
  GETALL_SUCCESS: "DASHBOARDDETAILS_GETALL_SUCCESS",
  GETALL_FAILURE: "DASHBOARDDETAILS_GETALL_FAILURE",

  LOADING_REQUEST: "LOADING_REQUEST",
};
